module.exports = __webpack_public_path__ + "static/media/ios_4_600.020b3630.png";